import { render, staticRenderFns } from "./subTitles.vue?vue&type=template&id=1f71d1de&scoped=true&"
import script from "./subTitles.vue?vue&type=script&lang=js&"
export * from "./subTitles.vue?vue&type=script&lang=js&"
import style0 from "./subTitles.vue?vue&type=style&index=0&id=1f71d1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71d1de",
  null
  
)

export default component.exports